import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SplashScreenService {
  public splashScreen = new EventEmitter(false);
  constructor() { }

  activateSplash(bool: boolean) {
    this.splashScreen.emit(bool);
  }
}
